import {
    ASSET_LIST_VIEW_ATTRIBUTES_RECEIVED,
    DELETE_PROPOSED_ASSETS,
    EDIT_ASSET_FORM_DATA_RECEIVED,
    GET_ASSET_CONFIG_DATA,
    GET_ASSET_DATA,
    GET_ASSET_LIST_VIEW_ATTRIBUTES,
    GET_EDIT_ASSET_FORM_DATA,
    GET_PROPOSED_ASSETS,
    IS_ANY_ASSET_PUBLISHED,
    POST_EDIT_ASSET_DATA,
    PUBLISH_PROPOSED_ASSETS,
    RECEIVED_ASSET_CONFIG_DATA,
    RECEIVED_ASSET_DATA,
    RECEIVED_POLYGON_ASSET_DATA,
    RECEIVED_SEGMENT_ASSET_DATA,
    SET_IS_ASSET_CREATED_OR_EDITED,
    SET_PROPOSED_ASSET_MARKERS,
    SET_PROPOSED_ASSETS_PARAMS,
    SET_SELECTED_ASSET_CONFIG_ID,
    SET_SELECTED_ASSET_IDS,
    SET_SELECTED_POLYGON_ASSET_IDS,
    SET_SELECTED_ROW_IDS,
    SHOW_ASSET_LIST_VIEW,
    SHOW_EXISTING_ASSET_LIST_VIEW,
    STORE_EXISTING_POLYGON_ASSETS_DATA,
    STORE_GEOSERVER_ASSETS_DATA,
    STORE_PROPOSED_ASSETS,
    STORE_REAL_TIME_POLYGON_DATA,
    TOGGLE_CREATE_POLYGON_ASSET_PANEL,
    TOGGLE_EDIT_ASSET_PANEL,
    TOGGLE_EDIT_POLYGON_ASSET_PANEL,
    TOGGLE_ASSET_ACTION_PERFORMED,
    SetIsAnyAssetPublishedAction,
    GetAssetDataAction,
    GetAssetConfigDataAction,
    ReceivedAssetDataAction,
    ReceivedPolygonAssetDataAction,
    ReceivedSegmentAssetDataAction,
    ReceivedAssetConfigDataAction,
    SetSelectedAssetIdsAction,
    SetSelectedPolygonAssetIdsAction,
    GetEditAssetFormDataAction,
    EditAssetFormDataReceivedAction,
    PostEditAssetDataAction,
    ToggleEditAssetPanelAction,
    ToggleEditPolygonAssetPanelAction,
    ToggleCreatePolygonAssetPanelAction,
    GetProposedAssetsAction,
    storeProposedAssetsAction,
    setProposedAssetMarkersAction,
    AssetListViewAttributesReceivedAction,
    SetProposedAssetsParamsAction,
    ShowAssetListViewAction,
    ShowExistingAssetListViewAction,
    SetIsAssetCreatedOrEditedAction,
    SetSelectedRowIdsAction,
    PublishProposedAssetsAction,
    DeleteProposedAssetsAction,
    StoreGeoserverAssetsDataAction,
    SetSelectedAssetConfigIdAction,
    StoreRealTimePolygonDataAction,
    StoreExistingPolygonAssetsDataAction,
    ReceivedDefaultPolygonAssetDataAction,
    RECEIVED_DEFAULT_POLYGON_ASSET_DATA,
    StoreEnabledAssetIdsAction,
    STORE_ENABLED_ASSET_IDS,
    EditAssetDataAction,
    EDIT_ASSET_DATA_ACTION,
    SelectedAssetColumnsAction,
    SELECTED_ASSET_COLUMNS,
    SET_SEGMENT_POINT_ASSET_DATA,
    SetSegmentPointAssetDataAction,
    SET_ASSETS_PARAMS,
    SetAssetsParamsAction,
    STORE_ASSETS,
    storeAssetsAction,
    GetAssetsAction,
    GET_ASSETS,
    SET_SELECTED_SUB_ASSETS,
    setSelectedSubAssetsAction,
    SHOW_EXISTING_SUB_ASSET_LIST_VIEW,
    ShowExistingSubAssetListViewAction
} from "./types";

import { createAction } from "@reduxjs/toolkit";

export const setIsAnyAssetPublished =
    createAction<SetIsAnyAssetPublishedAction["payload"]>(IS_ANY_ASSET_PUBLISHED);

export const getAssetData = createAction<GetAssetDataAction["payload"]>(GET_ASSET_DATA);

export const getAssets = createAction<GetAssetsAction["payload"]>(GET_ASSETS);

export const setSelectedSubAssets =
    createAction<setSelectedSubAssetsAction["payload"]>(SET_SELECTED_SUB_ASSETS);

export const getAssetConfigData =
    createAction<GetAssetConfigDataAction["payload"]>(GET_ASSET_CONFIG_DATA);

export const receivedAssetData =
    createAction<ReceivedAssetDataAction["payload"]>(RECEIVED_ASSET_DATA);

export const receivedPolygonAssetData = createAction<ReceivedPolygonAssetDataAction["payload"]>(
    RECEIVED_POLYGON_ASSET_DATA
);

export const receivedDefaultPolygonAssetData = createAction<
    ReceivedDefaultPolygonAssetDataAction["payload"]
>(RECEIVED_DEFAULT_POLYGON_ASSET_DATA);

export const receivedSegmentAssetData = createAction<ReceivedSegmentAssetDataAction["payload"]>(
    RECEIVED_SEGMENT_ASSET_DATA
);

export const editAssetDataAction =
    createAction<EditAssetDataAction["payload"]>(EDIT_ASSET_DATA_ACTION);

export const receivedAssetConfigData = createAction<ReceivedAssetConfigDataAction["payload"]>(
    RECEIVED_ASSET_CONFIG_DATA
);

export const storeEnabledAssetIds =
    createAction<StoreEnabledAssetIdsAction["payload"]>(STORE_ENABLED_ASSET_IDS);

export const setSelectedAssetIds =
    createAction<SetSelectedAssetIdsAction["payload"]>(SET_SELECTED_ASSET_IDS);

export const setSelectedPolygonAssetIds = createAction<SetSelectedPolygonAssetIdsAction["payload"]>(
    SET_SELECTED_POLYGON_ASSET_IDS
);

export const getEditAssetFormData =
    createAction<GetEditAssetFormDataAction["payload"]>(GET_EDIT_ASSET_FORM_DATA);

export const toggleAssetActionPerformed = createAction(TOGGLE_ASSET_ACTION_PERFORMED);

export const editAssetFormDataReceived = createAction<EditAssetFormDataReceivedAction["payload"]>(
    EDIT_ASSET_FORM_DATA_RECEIVED
);
export const postEditAssetData =
    createAction<PostEditAssetDataAction["payload"]>(POST_EDIT_ASSET_DATA);

export const toggleEditAssetPanel =
    createAction<ToggleEditAssetPanelAction["payload"]>(TOGGLE_EDIT_ASSET_PANEL);

export const toggleEditPolygonAssetPanel = createAction<
    ToggleEditPolygonAssetPanelAction["payload"]
>(TOGGLE_EDIT_POLYGON_ASSET_PANEL);

export const toggleCreatePolygonAssetPanel = createAction<
    ToggleCreatePolygonAssetPanelAction["payload"]
>(TOGGLE_CREATE_POLYGON_ASSET_PANEL);

export const getProposedAssets =
    createAction<GetProposedAssetsAction["payload"]>(GET_PROPOSED_ASSETS);

export const storeProposedAssets =
    createAction<storeProposedAssetsAction["payload"]>(STORE_PROPOSED_ASSETS);

export const storeAssets = createAction<storeAssetsAction["payload"]>(STORE_ASSETS);

export const setProposedAssetMarkers = createAction<setProposedAssetMarkersAction["payload"]>(
    SET_PROPOSED_ASSET_MARKERS
);

export const setSegmentPointAssetData = createAction<SetSegmentPointAssetDataAction["payload"]>(
    SET_SEGMENT_POINT_ASSET_DATA
);

export const getAssetListViewAttributes = createAction<{ params: { useAlternateApi: boolean } }>(
    GET_ASSET_LIST_VIEW_ATTRIBUTES
);

export const assetListViewAttributesReceived = createAction<
    AssetListViewAttributesReceivedAction["payload"]
>(ASSET_LIST_VIEW_ATTRIBUTES_RECEIVED);

export const setProposedAssetsParams = createAction<SetProposedAssetsParamsAction["payload"]>(
    SET_PROPOSED_ASSETS_PARAMS
);

export const setAssetsParams = createAction<SetAssetsParamsAction["payload"]>(SET_ASSETS_PARAMS);

export const showAssetListView =
    createAction<ShowAssetListViewAction["payload"]>(SHOW_ASSET_LIST_VIEW);

export const showExistingAssetListView = createAction<ShowExistingAssetListViewAction["payload"]>(
    SHOW_EXISTING_ASSET_LIST_VIEW
);

export const showExistingSubAssetListView = createAction<
    ShowExistingSubAssetListViewAction["payload"]
>(SHOW_EXISTING_SUB_ASSET_LIST_VIEW);

export const setIsAssetCreatedOrEdited = createAction<SetIsAssetCreatedOrEditedAction["payload"]>(
    SET_IS_ASSET_CREATED_OR_EDITED
);

export const setSelectedRowIds =
    createAction<SetSelectedRowIdsAction["payload"]>(SET_SELECTED_ROW_IDS);

export const publishProposedAssets =
    createAction<PublishProposedAssetsAction["payload"]>(PUBLISH_PROPOSED_ASSETS);

export const deleteProposedAssets =
    createAction<DeleteProposedAssetsAction["payload"]>(DELETE_PROPOSED_ASSETS);

export const storeGeoserverAssetsData = createAction<StoreGeoserverAssetsDataAction["payload"]>(
    STORE_GEOSERVER_ASSETS_DATA
);

export const setSelectedAssetConfigId = createAction<SetSelectedAssetConfigIdAction["payload"]>(
    SET_SELECTED_ASSET_CONFIG_ID
);

export const storeRealTimePolygonData = createAction<StoreRealTimePolygonDataAction["payload"]>(
    STORE_REAL_TIME_POLYGON_DATA
);

export const storeExistingPolygonAssetsData = createAction<
    StoreExistingPolygonAssetsDataAction["payload"]
>(STORE_EXISTING_POLYGON_ASSETS_DATA);

export const setSelectedAssetColumns =
    createAction<SelectedAssetColumnsAction["payload"]>(SELECTED_ASSET_COLUMNS);
